import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@storable/canaveral-components';
import { FLUID, MODERN_CLASSIC } from '../../../../../../constants/pageSets';
import PageSet from './PageSet';
import classes from './PageSetPicker.scss';

export default class PageSetPicker extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    isSaving: PropTypes.bool,
  };

  static defaultProps = {
    isSaving: false,
  };

  state = {
    selected: null,
  };

  handleSelect = () => {
    const { selected } = this.state;

    if (selected) {
      this.props.onSelect(selected);
    }
  };

  handleSelectSet = (pageSet) => {
    if (this.props.isSaving) {
      return;
    }

    this.setState({
      selected: pageSet === this.state.selected ? null : pageSet,
    });
  };

  render() {
    const { isSaving } = this.props;
    const { selected: selectedPageSet } = this.state;

    return (
      <Modal show aria-labelledby="page-set-picker">
        <Modal.Header>
          <Modal.Title id="page-set-picker">Build New Site</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.title}>Select a page to start with</div>
          <div className={classes.pageSets}>
            <PageSet
              pageSet={FLUID}
              onSelect={this.handleSelectSet}
              selected={selectedPageSet === FLUID}
            />
            <PageSet
              pageSet={MODERN_CLASSIC}
              onSelect={this.handleSelectSet}
              selected={selectedPageSet === MODERN_CLASSIC}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="sm"
            context="positive"
            loading={isSaving}
            disabled={!selectedPageSet}
            onClick={this.handleSelect}
          >
            Build Site!
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
